import React, { useEffect, useState } from "react";
import { initialProject } from "../../../system/initial/project";
import { project } from "../../../system/types/project/project";
import { RootState } from "../../../redux/reducers";
import { language } from "../../../system/types/project/language";
import { useSelector } from "react-redux";
import Icon from "@mdi/react";
import {mdiChevronLeft, mdiFormatAnnotationPlus, mdiFormatColorText} from "@mdi/js";
import { dispatch } from "../../../App";
import { actions } from "../../../redux";
import { useTranslations } from "../../../hooks/useTranslations";


interface props {
    showLanguagesStatus: string;
    setShowLanguagesStatus: React.Dispatch<React.SetStateAction<string>>;
}

const ListProjectLanguages = (props: props) => {

    const { t } = useTranslations();

    const [projectData, setProjectData] = useState<project>(initialProject);
    const [listLanguages, setListLanguages] = useState<language[]>([]);

    useSelector((state: RootState) => {
        if (state.project.projectData !== projectData) {
            setProjectData(state.project.projectData);
        }
    });

    const closeList = () => {
        props.setShowLanguagesStatus('close');
    }

    const addLanguage = () => {
        dispatch(actions.project.setPageCommand('editLanguage'));
        dispatch(actions.project.setPageCommandId(''));
    };

    const editLanguage = (isoCode: string) => {
        dispatch(actions.project.setPageCommand('editLanguage'));
        dispatch(actions.project.setPageCommandId(isoCode));
    }

    useEffect(() => {
        setListLanguages(projectData.languages);
    }, [projectData]);


    return (<>
        <div className="row mb-3 align-items-center">
            <span className="link" onClick={closeList}>
                <Icon path={mdiChevronLeft} size={1}/> {t('common.back')}
            </span>
        </div>
        <div className="row mb-3 align-items-center">
            <div className="col"><strong>{t('projects.availablelanguages')}</strong></div>
            <div className="col-auto">
                <button onClick={addLanguage} className="btn btn-outline-primary"><Icon path={mdiFormatAnnotationPlus}
                                                                                        size={1}/></button>
            </div>
        </div>
        <div className="row mb-3 align-items-center">
            <div className="col">{projectData.baseLanguage.name}</div>
        </div>
        {listLanguages.map((language) => (
            <div className="row mb-3 align-items-center" key={language.isoCode}>
                <div className="col">{language.name}</div>
                <div className="col-auto">
                    <button onClick={() => {
                        editLanguage(language.isoCode);
                    }} className="btn btn-outline-primary"><Icon path={mdiFormatColorText} size={1}/></button>
                </div>
            </div>
        ))}
    </>);
};

export {ListProjectLanguages};

